import { render, staticRenderFns } from "./unpaid-leave.vue?vue&type=template&id=30b148b8"
import script from "./unpaid-leave.vue?vue&type=script&lang=js"
export * from "./unpaid-leave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports